const TOKEN_KEY = "access_token";
const LEGACY_TOKEN_KEYS = ["accessToken", "token"];

export const saveToken = (token) => {
    localStorage.setItem(TOKEN_KEY, token);
    LEGACY_TOKEN_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const getToken = () => {
    return (
        localStorage.getItem(TOKEN_KEY) ||
        localStorage.getItem("accessToken") ||
        localStorage.getItem("token")
    );
};

export const removeToken = () => {
    localStorage.removeItem(TOKEN_KEY);
    LEGACY_TOKEN_KEYS.forEach((key) => localStorage.removeItem(key));
};


